import { DateFormat, formatDate, now } from "common";
import { Dayjs } from "dayjs";
import { SelectionState } from "types";
import create from "zustand";
import { CreatedAtRangeProps, DateFilterRange } from "./analyticsFilterStore";

const defaultRange = () => {
    return { from: now().subtract(1, "month").startOf("day"), to: now().endOf("day") };
};

export interface XolaBotEarningsReportFilter {
    assistTypes: SelectionState;
}

const defaultFilters: XolaBotEarningsReportFilter = {
    assistTypes: { all: true, selected: [] },
};

interface XolaBotEarningsReportStoreState {
    to?: Dayjs;
    from?: Dayjs;
    getFrom: () => Dayjs;
    getTo: () => Dayjs;
    filters: XolaBotEarningsReportFilter;
    setFilters: (filters: Partial<XolaBotEarningsReportFilter>) => void;
    resetFilters: (filters?: Partial<XolaBotEarningsReportFilter>) => void;
    setFrom: (date: Dayjs) => void;
    setTo: (date: Dayjs) => void;
    getDateParams: () => CreatedAtRangeProps;
}

export const useXolaBotEarningsReportFilterStore = create<XolaBotEarningsReportStoreState>((set, get) => ({
    from: undefined,
    to: undefined,
    filters: defaultFilters,

    getDateParams() {
        const params = [
            formatDate(get().getFrom(), DateFormat.DATE_TIME_ISO),
            formatDate(get().getTo(), DateFormat.DATE_TIME_ISO),
        ];
        return { [DateFilterRange.CREATED_AT]: params.join(",") };
    },

    setFilters(filters: Partial<XolaBotEarningsReportFilter>) {
        set((state) => ({ filters: { ...state.filters, ...filters } }));
    },

    resetFilters(filters?: Partial<XolaBotEarningsReportFilter>) {
        set({ filters: { ...defaultFilters, ...filters } });
    },

    getFrom() {
        return get().from ?? defaultRange().from;
    },

    getTo() {
        return get().to ?? defaultRange().to;
    },

    setFrom(from: Dayjs) {
        set(() => ({ from }));
    },

    setTo(to: Dayjs) {
        set(() => ({ to }));
    },
}));
